import { SelectItem } from './common/SelectItem';

enum MaritalStatus {
    AMarriedMan = 1,
    AMarriedPerson,
    AMarriedWoman,
    ASingleMan,
    ASinglePerson,
    ASingleWoman,
    AWidow,
    AWidower,
    HusbandAndHusband,
    HusbandAndWife,
    WifeAndHusband,
    WifeAndWife,
}

export default MaritalStatus;

export const convertMartialStatusesToSelectList = (): SelectItem[] => {
    return Object.keys(MaritalStatus)
        .filter((value: string | number) => isNaN(Number(value)) === false)
        .map(
            (key: string) =>
                new SelectItem(
                    parseInt(key, 10),
                    MaritalStatus[parseInt(key, 10)]
                        .replace('of', ' of')
                        .replace(/([A-Z])/g, ' $1')
                        .trim()
                        .toLowerCase()
                )
        );
};



// WEBPACK FOOTER //
// ./src/models/MaritalStatus.ts